export default{
    "请填写简介": "请填写简介",
    "请输入正确的邮箱": "请输入正确的邮箱",
    "请搜索或选择国家": "请搜索或选择国家",
    "搜索已发布的作品": "搜索已发布的作品",
    "请输入邮箱": "请输入邮箱",
    "请输入公司座机号": "请输入公司座机号",
    "请输入微信号": "请输入微信号",
    "请介绍一下您的团队或自己": "请介绍一下您的团队或自己",
    "最多添加3个，上下拖拽可调整排序": "最多添加3个，上下拖拽可调整排序",
    "找项目": "找项目",
    "接项目": "接项目",
    "以下案例为平台用户已落地项目": "以下案例为平台用户已落地项目",
    "团队介绍": "团队介绍",
    "添加案例": "添加案例",
    "上传新作品": "上传新作品",
    "该作品已添加": "该作品已添加",
    "请添加案例": "请添加案例",
    "项目对接": "项目对接",
    "MANA项目对接": "MANA项目对接",
    "创意内容供应和服务端与需求端双向对接，专业和产业链协同协作对接。":"创意内容供应和服务端与需求端双向对接，专业和产业链协同协作对接。",
    "MANA平台提供免费发布和自主匹配服务。": "MANA平台提供免费发布和自主匹配服务。",
    "发布项目": "发布项目",
    "参考案例": "参考案例",
    "应用场景": "应用场景",
    "查看全部案例": "查看全部案例",
    "专业平台，精准资源": "专业平台，精准资源",
    "MANA是全球艺术与科技创意内容分享与市场转化的专业平台；是新媒体艺术领域最具影响力的行业媒体之一。": "MANA是全球艺术与科技创意内容分享与市场转化的专业平台；是新媒体艺术领域最具影响力的行业媒体之一。",
    "对接海量全球创作者资源": "对接海量全球创作者资源",
    "您将有机会对接到覆盖全球80%国家和地区的创作团队，合作领域涉及文旅、商业地产、医疗健康、休闲娱乐、科技教育等，助您找到最合适的创作者。": "您将有机会对接到覆盖全球80%国家和地区的创作团队，合作领域涉及文旅、商业地产、医疗健康、休闲娱乐、科技教育等，助您找到最合适的创作者。",
    "免费推广机会": "免费推广机会",
    "在MANA对接成功的项目，有机会获得平台免费推广资源。": "在MANA对接成功的项目，有机会获得平台免费推广资源。",
    "服务流程": "服务流程",
    "提交需求": "提交需求",
    "审核发布": "审核发布",
    "项目需求需要与科技艺术领域相关。审核结果将会在1个工作日内以邮件形式告知您。": "项目需求需要与科技艺术领域相关。审核结果将会在1个工作日内以邮件形式告知您。",
    "对接资源": "对接资源",
    "创作者的投递信息将以系统邮件形式发送到您的邮箱，需求发布后请注意查收邮件。": "创作者的投递信息将以系统邮件形式发送到您的邮箱，需求发布后请注意查收邮件。",
    "其它服务": "其它服务",
    "商务客服邮箱": "如若想要通过MANA推荐创作团队/获取创作团队信息，请联系商务客服邮箱：",
    "此服务为收费服务，按推荐/提供团队信息的数量收费，推荐/提供团队信息收费199元，或者可以购买年费服务。年度服务收费999元（全年推荐不超过20个团队）": "此服务为收费服务，按推荐/提供团队信息的数量收费，推荐/提供团队信息收费199元，或者可以购买年费服务。年度服务收费999元（全年推荐不超过20个团队）",
    "MANA平台入驻创作者专属": "MANA平台入驻创作者专属",
    "只有入驻MANA平台并发布作品的创作者才可以接项目": "只有入驻MANA平台并发布作品的创作者才可以接项目",
    "入驻并发布作品": "入驻并发布作品",
    "类型": "类型",
    "地点": "地点",
    "项目预算": "项目预算",
    "已结束": "已结束",
    "截止": "截止",
    "服务成果": "服务成果",
    "最晚交付时间": "最晚交付时间",
    "需求方类型": "需求方类型",
    "您尚未成为MANA平台创作者": "您尚未成为MANA平台创作者",
    "发布1部及以上原创作品，即可成为MANA平台创作者，才可以接项目哦～": "发布1部及以上原创作品，即可成为MANA平台创作者，才可以接项目哦～",
    "去发布": "去发布",
    "请填写以下信息，我们将把您填写的信息通过系统自动发送邮件到需求方的邮箱。": "请填写以下信息，我们将把您填写的信息通过系统自动发送邮件到需求方的邮箱。",
    "查看邮件示例": "查看邮件示例",
    "以下默认为您在个人中心上填写的信息。修改后仅用于邮件发送，将不会同时修改您的个人资料。": "以下默认为您在个人中心上填写的信息。修改后仅用于邮件发送，将不会同时修改您的个人资料。",
    "暂无": "暂无",
    "找供应商": "找供应商",
    "删除": "删除",
    "找全案服务": "找全案服务",
    "找专业服务": "找专业服务",
    "咨询顾问、策划策展、创意创作、软硬件及工程技术、项目运营": "咨询顾问、策划策展、创意创作、软硬件及工程技术、项目运营",
    "咨询-方案-资源-落地-运营": "咨询-方案-资源-落地-运营",
    "最多添加3个": "最多添加3个",
    "全案服务": "全案服务 ",
    "咨询顾问": "咨询顾问 ",
    "策展策划": "策展策划 ",
    "创意创作": "创意创作 ",
    "软硬件及工程技术": "软硬件及工程技术 ",
    "项目运营": "项目运营 ",
    "整体解决方案": "整体解决方案 ",
    "资讯、策划": "资讯、策划 ",
    "方案设计": "方案设计 ",
    "项目执行": "项目执行 ",
    "3万以下": "3万以下",
    "3-10万": "3-10万",
    "10-20万": "10-20万",
    "20-50万": "20-50万",
    "50-100万": "50-100万",
    "100万以上": "100万以上",

}



// WEBPACK FOOTER //
// ./src/languages/cn/project.js